/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  EnviarEmailsParaSolicEmLoteMutationRequest,
  EnviarEmailsParaSolicEmLoteMutationResponse,
  EnviarEmailsParaSolicEmLote401,
} from '../../types/EnviarEmailsParaSolicEmLote.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getEnviarEmailsParaSolicEmLoteUrl() {
  const res = {
    method: 'POST',
    url: `/solic/v2/enviar-emails-para-solic-em-lote` as const,
  };
  return res;
}

/**
 * {@link /solic/v2/enviar-emails-para-solic-em-lote}
 */
export async function enviarEmailsParaSolicEmLote(
  data?: EnviarEmailsParaSolicEmLoteMutationRequest,
  config: Partial<RequestConfig<EnviarEmailsParaSolicEmLoteMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    EnviarEmailsParaSolicEmLoteMutationResponse,
    ResponseErrorConfig<EnviarEmailsParaSolicEmLote401>,
    EnviarEmailsParaSolicEmLoteMutationRequest
  >({
    method: 'POST',
    url: getEnviarEmailsParaSolicEmLoteUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
